// See https://redmine.3pc.de/issues/108489

const powermailSubmitButtonSelector =
  '.styled-button--powermail-submit[type="submit"]';
const powermailSubmitButtons = document.querySelectorAll(
  powermailSubmitButtonSelector
);

const preventDoubleClick = e => {
  const target =
    e.target.getAttribute('type') === 'submit'
      ? e.target
      : e.target.closest(powermailSubmitButtonSelector);
  setTimeout(function () {
    target.setAttribute('disabled', 'disabled');
  }, 0);
};

powermailSubmitButtons.forEach(button => {
  button.addEventListener('click', preventDoubleClick);
});
